// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"321":"5ed384f2","2133":"5ed384f2","9553":"58297519"}[chunkId] + ".chunk.css";
};